import { LinearProgress } from '@mui/material'
import { startRegistration } from '@simplewebauthn/browser'
import { PublicKeyCredentialCreationOptionsJSON } from '@simplewebauthn/typescript-types'
import AuthTemplate from 'components/templates/AuthTemplate'
import { URL_APP } from 'helpers/config'
import useEffectOnce from 'hooks/useEffectOnce'
import useShowError from 'hooks/useShowError'
import axios from 'providers/axios'
import React from 'react'

const ConnectPasskey: React.FC = () => {
  const showError = useShowError()

  useEffectOnce(() => {
    const connect = async () => {
      try {
        const { data: optionsData } = await axios.post<{ options: PublicKeyCredentialCreationOptionsJSON }>(
          '/passkey/generateRegistrationOptions'
        )
        if (!optionsData) throw new Error('No optionsData')
        console.log('options', optionsData.options)
        const registration = await startRegistration(optionsData.options)
        console.log('registration', registration)
        const { data: creationData } = await axios.post<{ success: boolean }>('/passkey/createPasskeyAuthenticator', {
          registration,
        })
        if (creationData.success) {
          window.location.href = `${URL_APP}/settings/user?mode=security`
        }
      } catch (error) {
        showError("Error. Couldn't connect your passkey")
        setTimeout(() => {
          window.location.href = `${URL_APP}/settings/user?mode=security`
        }, 2000)
      }
    }
    connect()
  })

  return (
    <AuthTemplate>
      <h1>Connect Your Passkey</h1>

      <LinearProgress sx={{ my: '40px', maxWidth: '400px', mx: 'auto' }} />
    </AuthTemplate>
  )
}

export default ConnectPasskey
